import * as React from 'react';
import ApplicationLanguage from '../containers/ApplicationLanguage';

export default (props) => <ApplicationLanguage {...props} />

